module.exports = __webpack_public_path__ + "assets/1default-alt.741c03e6.svg";